import React from "react";

const blogs = [
  {
    img: "assets/images/technographics-is-the-secret-ingredient-to-precision-messaging.webp",
    title: "5 Reasons Why Technographics is the Secret Ingredient to Precision Messaging",
    // date: "7 August, 2024",
    description:
      "In a market where differentiation is increasingly difficult, the organizations that win are those that understand their prospects at a deeper, more operational level. Demographics and firmographics offer useful context, but they no longer provide ...",
    link: "/why-technographics-is-the-secret-ingredient-to-precision-messaging",
    alt:"Technographics-is-the-secret-ingredient-to-precision-messaging",
  },
   {
    img: "assets/images/how-technographics-drive-smarter-gtm-abm-and-competitive-advantage .webp",
    title: "How Technographics Drive Smarter GTM, ABM, and Competitive Advantage",
    // date: "7 August, 2024",
    description:
      "In enterprise decision-making, the strongest competitive advantages are often created by clarity about markets, customers, and the systems that power them. For many organizations, that clarity increasingly comes from understanding...",
    link: "/how-technographics-drive-smarter-gtm-abm-and-competitive-advantage",
    alt:"how-technographics-drive-smarter-gtm-abm-and-competitive-advantage",
  },
    {
    img: "assets/images/competitors-growth.webp",
    title: "Winning Renewals You Never Had: Turning Your Competitor’s Customers into Your Growth Engine",
    // date: "7 August, 2024",
    description:
      "Every GTM strategy talks about “net new.” New leads, new markets, new opportunities. But here’s the truth: most new pipeline is wasted. Research shows up to 60% of outbound efforts target buyers still locked into contracts...",
    link: "/turning-your-competitors-customers-into-your-growth-engine",
    alt:"turning-your-competitors-customers-into-your-growth-engine",
  },
  {
    img: "assets/images/renewal-intelligence-win-against-the-odd.webp",
    title: "Customer Success Meets Competitive Strategy: How Renewal Intelligence Wins Against the Odds",
    // date: "7 August, 2024",
    description:
      "Customer Success used to be defined by satisfaction surveys, onboarding checklists, and renewal rates. It was about defense, holding onto what you already had. But in today’s B2B landscape, that isn’t enough.",
    link: "/how-renewal-intelligence-win-against-the-odd",
    alt:"renewal ontelligence win against the odd",
  },
   {
    img: "assets/images/renewals-arr.webp",
    title: "Renewals Are the New ARR: 4 Smart Ways to Build Predictable Growth Using Renewal Intelligence",
    // date: "7 August, 2024",
    description:
      "For years, Annual Recurring Revenue (ARR) has been the trophy metric in B2B tech. Land the logo, lock the deal, scale the chart. But here’s the thing: real, sustainable growth doesn’t come from the next big logo.",
    link: "/renewal-are-the-arr-4-smart-ways-to-build-drive-growth-with-renewal-intelligence",
    alt:"renewal annual recurring revenue",
  },
  {
    img: "assets/images/renewal-blog.png",
    title: "The Strategic Imperative of Renewal Timing: Mastering the 100-Day Advantage",
    // date: "7 August, 2024",
    description:
      "Businesses unknowingly leave revenue on the table due to misaligned subscription renewals, simultaneously missing prime opportunities to win new business from competitors.  In the high-stakes world of recurring revenue, timing isn't just...",
    link: "/strategic-imperative-of-renewal-timings-mastering-the-100-day-advantage",
    alt:"strategic imperative of renewal timing",
  },
  {
    img: "assets/images/blog1.webp",
    title: "Unlocking the Full Potential of Data-Driven Business Strategies",
    date: "7 August, 2024",
    description:
      "In today’s hyper-competitive landscape, data is the lifeblood of business success. Companies that effectively harness the power of data are better positioned to innovate, optimize operations, and drive growth.",
    link: "/blog1details",
    alt:"data driven strategies",
  },
  {
    img: "assets/images/blog2.webp",
    title: "How Data Adoption is Shaping the Future of Connectivity.",
    date: "14 August, 2024",
    description:
      "The global telecommunications industry is experiencing a profound transformation, driven by rapid technological advancements, the widespread adoption of smart devices and the growing demand for high-speed internet connectivity.",
    link: "/blog2details",
    alt:"data adoption",
  },
  {
    img: "assets/images/blog4.webp",
    title: "Why Data-Driven Go-to-Market Innovation Matters for Industrial Companies",
    date: "21 August, 2024",
    description:
      "Industrial companies are at a pivotal moment where they must innovate their traditional go-to-market strategies by embracing digital transformation. The confluence of emerging digital commerce...",
    link: "/blog3details",
     alt:"gtm innovation",
  },
  {
    img: "assets/images/blog5.webp",
    title: "Why Companies Are Taking Control of Their Cloud Infrastructure?",
    date: "4 September, 2024",
    description:
      "With the rising complexity of cloud services and evolving business needs, many companies are reconsidering their reliance on public cloud infrastructure and opting for private or hybrid cloud models, including moving to their own cloud data servers.",
    link: "/blog4details",
     alt:"cloud-infrastructure",
  },
  {
    img: "assets/images/blog6.webp",
    title: "The Impact of Data-Driven Transformation in the IT Industry Across all Regions",
    date: "11 September, 2024",
    description:
      "The IT industry is being transformed by the power of data. From cloud computing to artificial intelligence, data-driven technologies are reshaping businesses across the globe. This whitepaper delves into the data-driven transformation...",
    link: "/blog5details",
     alt:"data driven transformation",
  },
];

const BlogSection = () => {
  return (
    <div className="blog_area pt-85 pb-65">
      <div className="container">
        <div className="row">
          {blogs.map((blog, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="single_blog mb-30">
                <div className="single_blog_thumb pb-4">
                  <a href={blog.link}>
                    <img src={blog.img} alt={blog.alt} />
                  </a>
                </div>
                <div className="single_blog_content pl-4 pr-4">
                  <div className="techno_blog_meta text-left">
                    <span className="meta-date">{blog.date}</span>
                  </div>
                  <div className="blog_page_title pb-1 pt-4 text-left">
                    <h3>
                      <a href={blog.link}>{blog.title}</a>
                    </h3>
                  </div>
                  {blog.description && (
                    <div className="blog_description text-left">
                      <p>{blog.description}</p>
                    </div>
                  )}
                  {blog.description && (
                    <div className="blog_page_button pb-4 text-left">
                      <a href={blog.link} className="read-more-link">
                        Read More{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                          style={{ marginLeft: "5px" }}
                        >
                          <path
                            fillRule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793L9.146 4.354a.5.5 0 1 1 .708-.708l4.5 4.5a.498.498 0 0 1 .146.35.498.498 0 0 1-.146.35l-4.5 4.5a.5.5 0 1 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
